/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseUpdateError } from './ResponseUpdateError';
import {
    ResponseUpdateErrorFromJSON,
    ResponseUpdateErrorFromJSONTyped,
    ResponseUpdateErrorToJSON,
    ResponseUpdateErrorToJSONTyped,
} from './ResponseUpdateError';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * データ登録系レスポンス
 * @export
 * @interface ResponseUpdate
 */
export interface ResponseUpdate {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseUpdate
     */
    result: ResponseResult;
    /**
     * 
     * @type {Array<ResponseUpdateError>}
     * @memberof ResponseUpdate
     */
    errors: Array<ResponseUpdateError> | null;
    /**
     * 
     * @type {number}
     * @memberof ResponseUpdate
     */
    updateCount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ResponseUpdate
     */
    lastUpdateDatetime: Date | null;
}

/**
 * Check if a given object implements the ResponseUpdate interface.
 */
export function instanceOfResponseUpdate(value: object): value is ResponseUpdate {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    if (!('updateCount' in value) || value['updateCount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    return true;
}

export function ResponseUpdateFromJSON(json: any): ResponseUpdate {
    return ResponseUpdateFromJSONTyped(json, false);
}

export function ResponseUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'errors': (json['errors'] == null ? null : (json['errors'] as Array<any>).map(ResponseUpdateErrorFromJSON)),
        'updateCount': json['update_count'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
    };
}

export function ResponseUpdateToJSON(json: any): ResponseUpdate {
    return ResponseUpdateToJSONTyped(json, false);
}

export function ResponseUpdateToJSONTyped(value?: ResponseUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'errors': (value['errors'] == null ? null : (value['errors'] as Array<any>).map(ResponseUpdateErrorToJSON)),
        'update_count': value['updateCount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
    };
}

